import catalog from './reading.json';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const LATEST_ON_HOME = 4;

export function formatReadingDate(iso) {
  const [year, month, day] = iso.split('-');
  const name = MONTHS[Number(month) - 1];
  return day ? `${Number(day)} ${name} ${year}` : `${name} ${year}`;
}

function timeValue(iso) {
  const [year, month, day] = iso.split('-').map(Number);
  return Date.UTC(year, month - 1, day || 1);
}

export function readingByDate(items = catalog) {
  return [...items].sort(
    (a, b) => timeValue(b.date) - timeValue(a.date) || a.title.localeCompare(b.title)
  );
}

export const latestReading = readingByDate().slice(0, LATEST_ON_HOME);
